import { Collapse, Modal, Skeleton } from "antd";
import React, { useState } from "react";
import FavoriteListItem from "./FavoriteListItem";
import FavorListItemHeader from "./FavoriListItemHeader";
import { useGetFavoriteList } from "../ServerSideStates";
import CustomNoData from "apps/Common/CustomNoData";
import AddOrUpdateFavoriteList from "./AddOrUpdateFavoriList";
import endPoints from "../EndPoints"
import { useQueryClient } from "react-query";

const FavoriteList = () => {
  const { Panel } = Collapse;
const queryClient = useQueryClient()
  const favoriteList = useGetFavoriteList();
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const [isShowEditListModal, setIsShowEditListModal] = useState(false);

  return (
    <>
      {
        <Skeleton loading={favoriteList.isLoading || favoriteList.isFetching}>
          {favoriteList?.data?.data?.length > 0 ? (
            <>
              <Collapse defaultActiveKey={["1"]} className="!rounded-lg">
                {favoriteList?.data?.data?.map((item: any) => {
                  return (
                    <>
                      <Panel

                        header={
                          <FavorListItemHeader
                            item={item}
                            setSelectedRecord={setSelectedRecord}
                            setIsShowEditListModal={setIsShowEditListModal}
                          />
                        }
                        key={item.id}
                        className="!bg-[#f4f4f4] "
                      >
                        <FavoriteListItem favoriteListItem={item} />
                      </Panel>
                    </>
                  );
                })}
              </Collapse>
            </>
          ) : (
            <>
              <CustomNoData />
            </>
          )}
        </Skeleton>
      }

      <Modal
        title="Liste Ekle"
        open={isShowEditListModal}
        onCancel={() => {
          setIsShowEditListModal(false);
        }}
        footer={false}
      >
        <AddOrUpdateFavoriteList selectedRecord={selectedRecord} 
        onFinish={()=>{
          setIsShowEditListModal(false);
          queryClient.resetQueries({
            queryKey: endPoints.getFavoriteListFilter,
            exact: false,
          });
        }}
        />
      </Modal>
    </>
  );
};

export default FavoriteList;
